import React, { useEffect, useRef, useState } from "react";
import { useInViewport } from "react-in-viewport";

// QRCode
import QRCode from "../../image/qrcode.svg";

// Hooks
import useDevice from "../../hooks/useDevice";

// Components
import { Fade, Button, Divider, Typography } from "@mui/material";

const RSVP = (props) => {
  const contentRef = useRef();
  const [startTransition, setStartTransition] = useState(false);
  const { inViewport } = useInViewport(contentRef);
  const { device } = useDevice();

  useEffect(() => {
    if (inViewport) setStartTransition(true);
  }, [inViewport]);

  return (
    <div {...props} className={`vjc_main-rsvp ${device}`}>
      <Divider sx={{ marginBottom: "50px" }}>
        <Typography variant="h1" sx={{ fontSize: "26px" }}>
          R S V P
        </Typography>
      </Divider>

      <Fade in={startTransition} timeout={2500}>
        <Typography variant="body2" color="text.secondary" ref={contentRef}>
          We are overjoyed to invite you to join us in celebrating our wedding!
          Your presence would mean the world to us as we embark on this new
          chapter of our lives.
        </Typography>
      </Fade>

      <Fade in={startTransition} timeout={2500}>
        <Typography variant="body2" color="text.secondary">
          To help us make our special day perfect, we kindly ask you to RSVP by <span style={{ fontWeight: "700" }}>
            January 8 2026.
          </span>{" "}
          This will ensure we can accommodate all our beloved
          guests and make appropriate arrangements.{" "}
          <span style={{ fontWeight: "700" }}>
            Please scan the QR code below to be redirected to our RSVP Google
            Form
          </span>
        </Typography>
      </Fade>

      <Fade in={startTransition} timeout={3500}>
        <img src={QRCode} alt="qrcode" />
      </Fade>

      <Fade in={startTransition} timeout={3500}>
        <Divider style={{ margin: "20px 0px", width: "20%" }}>
          <Typography variant="body2" color="text.secondary">
            OR
          </Typography>
        </Divider>
      </Fade>
      <Fade in={startTransition} timeout={3500}>
        <Button
          variant="outlined"
          onClick={() => {
            window.open("https://docs.google.com/forms/d/e/1FAIpQLSde94maUElvxpBv02nn0qMIws_1KJdhte26TuttcUgeOSFcYw/viewform");
          }}
          style={{ marginBottom: "20px" }}
        >
          RSVP Google Form
        </Button>
      </Fade>

      <Fade in={startTransition} timeout={4500}>
        <Typography
          variant="body2"
          color="text.secondary"
          style={{ marginTop: "20px" }}
        >
          We are so excited to share this momentous occasion with you and create
          unforgettable memories together. Thank you for being a part of our
          lives and for joining us on this joyous day.
        </Typography>
      </Fade>
    </div>
  );
};

export default RSVP;
